import Vue from 'vue'
import ConfirmDialog from './ConfirmDialog'

let instance
const ConfirmConstructor = Vue.extend(ConfirmDialog)

const initInstance = () => {
  instance = new ConfirmConstructor({
    el: document.createElement('div')
  })
  document.body.appendChild(instance.$el)
}

const destroyDialog = (dialog) => {
  dialog.$destroy()
  document.body.removeChild(dialog.$el)
}

const Confirm = (content) => {
  const c = {
    title: 'Please confirm',
    text: 'Are you sure?',
    confirmButtonType: 'primary',
    confirmButtonText: 'Confirm',
    cancelButtonType: 'default',
    cancelButtonText: 'Cancel'
  }

  initInstance()
  instance.content = { ...c, ...content }

  return new Promise((resolve) => {
    instance.isOpen = true

    const { confirm } = instance
    const { cancel } = instance

    instance.confirm = () => {
      confirm()
      return resolve(true)
    }

    instance.cancel = () => {
      cancel()
      return resolve(false)
    }
  })
    .then((confirm) => {
      destroyDialog(instance)
      return confirm
    })
}

export default {
  install(opt) {
    const vue = opt
    vue.prototype.$confirm = Confirm
  }
}



// WEBPACK FOOTER //
// ./src/plugins/ConfirmDialog/index.js